import React from 'react';

import { Box, IconButton } from '@mui/material';
import moment from 'moment-timezone';

import { DATE_DISPLAY_FORMATS } from '@commons/DatePickers/constants';
import { getTheme } from '@commons/utils/theme';
import Text, { ENUM_FONTS } from '@commons/Text';

const CHEVRON_LEFT_ICON = '/images/inpulse/chevron-left-white-small.svg';
const CHEVRON_RIGHT_ICON = '/images/inpulse/chevron-right-white-small.svg';

const IconButtonSx = (theme) => ({
  background: theme.colors.blacks.ipBlack1,
  width: '24px',
  height: '24px',
});

const dateHasValidTimeSlots = (timeSlotsGroupedByDate, date) => {
  const timeSlotsOfTheDay = timeSlotsGroupedByDate?.[date] || [];

  if (timeSlotsOfTheDay.length === 0) {
    return false;
  }

  if (timeSlotsOfTheDay.length === 1 && timeSlotsOfTheDay[0].name === null) {
    return false;
  }

  return true;
};

export const DateNavigator = ({
  selectedDate,
  maxPastDate,
  maxFutureDate,
  handleDateChange,
  isDisabled,
  timeSlotsGroupedByDate,
}) => {
  const theme = getTheme();

  const prevDate = moment(selectedDate)
    .subtract(1, 'day')
    .format(DATE_DISPLAY_FORMATS.DASHED_YEAR_MONTH_DAY);
  const nextDate = moment(selectedDate)
    .add(1, 'day')
    .format(DATE_DISPLAY_FORMATS.DASHED_YEAR_MONTH_DAY);

  // Check if dates are outside the allowed range
  const isPrevDateOutOfRange = maxPastDate
    ? moment(selectedDate).isSame(maxPastDate, 'day')
    : false;
  const isNextDateOutOfRange = maxFutureDate
    ? moment(selectedDate).isSame(maxFutureDate, 'day')
    : false;

  // If timeSlotsGroupedByDate is provided, also check for valid time slots
  const hidePrevButton = timeSlotsGroupedByDate
    ? !dateHasValidTimeSlots(timeSlotsGroupedByDate, prevDate) || isPrevDateOutOfRange
    : isPrevDateOutOfRange;

  const hideNextButton = timeSlotsGroupedByDate
    ? !dateHasValidTimeSlots(timeSlotsGroupedByDate, nextDate) || isNextDateOutOfRange
    : isNextDateOutOfRange;

  const iconButtonStyle = IconButtonSx(theme);

  return (
    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', minWidth: '160px' }}>
      <IconButton
        disabled={hidePrevButton || isDisabled}
        sx={{
          ...iconButtonStyle,
          visibility: hidePrevButton ? 'hidden' : 'visible',
        }}
        onClick={() => handleDateChange('prev')}
      >
        <img src={CHEVRON_LEFT_ICON} />
      </IconButton>
      <Box sx={{ width: '140px', textAlign: 'center' }}>
        <Text font={ENUM_FONTS.H3_BOLD_70}>
          {moment(selectedDate).format(DATE_DISPLAY_FORMATS.CONDENSED_DAY_DATE_MONTH_YEAR)}
        </Text>
      </Box>
      <IconButton
        disabled={hideNextButton || isDisabled}
        sx={{
          ...iconButtonStyle,
          visibility: hideNextButton ? 'hidden' : 'visible',
        }}
        onClick={() => handleDateChange('next')}
      >
        <img src={CHEVRON_RIGHT_ICON} />
      </IconButton>
    </Box>
  );
};
